module.exports = __webpack_public_path__ + "img/my_gift_icon.d1f9e11b.svg";